/**
 * Configuration data for the DataRequest view
 * Contains all metrics and locations options
 */

export const METRICS = [
  { value: "attenuation", label: "Attenuations" },
  { value: "cellhub", label: "CellHub Data" },
  { value: "plmn", label: "PLMN(s)" },
  { value: "connection", label: "S1 Connections" },
  { value: "coredump", label: "Coredump Count" },
  { value: "eNB", label: "eNB Data" },
  { value: "fiber", label: "Optical Levels" },
  { value: "frequency", label: "Broadcast EARFCN" },
  { value: "lock", label: "Cell Lock Status" },
  { value: "loss", label: "Return Loss value" },
  { value: "power", label: "RF Power" },
  { value: "uplink", label: "Uplink RSSI" },
  { value: "downlink", label: "Downlink Power" },
  { value: "sectors", label: "Sector Count" },
  { value: "temperature", label: "Temperature" },
  { value: "SAS", label: "SAS information" },
  { value: "mocn", label: "MOCN Attachment" },
  { value: "tdd", label: "TDD Settings" },
  { value: "timings", label: "Timings" },
  { value: "software", label: "BBU Software" },
  { value: "system", label: "System Information" },
  { value: "CBSD", label: "CBSD Count" },
  { value: "alarms", label: "Mains Alarm Count" },
  { value: "dpcert", label: "Domain Proxy Certificate Expiration" },
  { value: "gps", label: "GPS Status" },
  { value: "subscribers", label: "UE Counts" },
];

export const LOCATIONS = [
  { value: "62", label: "All SU" },
  { value: "82", label: "Caesars NOBU"},
  { value: "87", label: "T-Mobile FOA"},
  { value: "85", label: "Verizon FOA"},
  { value: "86", label: "Windsor"},
  { value: "43", label: "Dome" },
  { value: "31", label: "Barnes" },
  { value: "32", label: "BBB" },
  { value: "33", label: "Bird" },
  { value: "34", label: "Booth" },
  { value: "35", label: "Bowne" },
  { value: "37", label: "Carnegie" },
  { value: "38", label: "CST" },
  { value: "39", label: "Day" },
  { value: "40", label: "Dellplain" },
  { value: "42", label: "Dineen" },
  { value: "45", label: "Ernie" },
  { value: "46", label: "Falks" },
  { value: "47", label: "Flint" },
  { value: "48", label: "Haven" },
  { value: "50", label: "HBCrouse" },
  { value: "51", label: "Hinds" },
  { value: "52", label: "Lally" },
  { value: "53", label: "Machinery" },
  { value: "68", label: "Marley" },
  { value: "54", label: "Maxwell" },
  { value: "56", label: "Newhouse" },
  { value: "71", label: "Physics" },
  { value: "57", label: "Sadler" },
  { value: "58", label: "Schine" },
  { value: "59", label: "Shaffer" },
  { value: "60", label: "Shaw" },
  { value: "61", label: "SIMS" },
  { value: "64", label: "Watson" },
  { value: "65", label: "Whitman" },
  { value: "66", label: "Womens" },
];

/**
 * Get metric label by value
 * @param {string} value - The metric value
 * @returns {string} The metric label or the value if not found
 */
export const getMetricLabel = (value) => {
  const metric = METRICS.find((m) => m.value === value);
  return metric?.label || value;
};

/**
 * Get location label by value
 * @param {string} value - The location value
 * @returns {string} The location label or the value if not found
 */
export const getLocationLabel = (value) => {
  const location = LOCATIONS.find((l) => l.value === value);
  return location?.label || value;
};
